<template>
    <div>
        <CommonHeader/>
        <div class="container" style="margin-top: 20px;box-shadow: rgba(0, 0, 0, 0.2) 0 2px 10px;min-height: calc(100vh - 56px - 108px);background: #fff">
            <div class="bg-white">
                <a-row>
                    <a-col :span="24">
                        <a-card>
                            <a-breadcrumb class="border-bottom pb-5">
                                <a-breadcrumb-item><a href="javascript:;" @click="findPass">帮助中心</a></a-breadcrumb-item>
                                <a-breadcrumb-item>项目相关问题</a-breadcrumb-item>
                            </a-breadcrumb>
                            <a-tabs class="mt-5" :default-active-key="qqq" tabPosition="left">
                                <a-tab-pane key="1" tab="项目报名">
                                    <h1>项目报名</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">进入采购公告报名</div>
                                            <span slot="description">
                                                <img src="../../img/help/t1.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">点击<span class="ml-3 mr-3 color-red">“我要报名”</span>没有进行单位认证，不能参与采购项目，会提示您进行单位认证！</div>
                                            <span slot="description">
                                                <img src="../../img/help/t2.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">勾选要报名的包组</div>
                                            <span slot="description">
                                                <img src="../../img/help/t3.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">支付报名费用<span class="color-red">（报名费用以实际项目为准）</span></div>
                                            <span slot="description">
                                                <img src="../../img/help/t4.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">报名成功后可在我的项目找到自己的项目</div>
                                            <span slot="description">
                                                <img src="../../img/help/t5.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="2" tab="项目信息">
                                    <h1>项目信息、包组信息</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">项目信息</div>
                                            <span slot="description">
                                                <img src="../../img/help/t6.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">包组信息</div>
                                            <span slot="description">
                                                <img src="../../img/help/t7.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="3" tab="投标保证金">
                                    <img style="margin: auto" src="../../img/p3.png">
                                </a-tab-pane>
                                <a-tab-pane key="4" tab="项目答疑">
                                    <h1>项目答疑</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">项目答疑在竞价开始前1天不再接受线上提问。</div>
                                            <span slot="description">
                                                <img src="../../img/help/t8.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="5" tab="项目竞价">
                                    <h1>项目竞价</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">开始竞价（以下为模拟竞价页面截图）</div>
                                            <span slot="description">
                                                <img src="../../img/help/t9.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">正式开始竞价流程指引</div>
                                            <span slot="description">
                                                <img src="../../img/help/t10.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">提交报价，确认提交后将不可撤回。</div>
                                            <span slot="description">
                                                <img src="../../img/help/t11.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="6" tab="竞价结果">
                                    <h1>竞价结果</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">请下载<span class="color-red">《供应商成交报价确认函模板》</span>，打印盖章后上传。请在两个工作日内上传，否则采购人有权更换成交供应商。
                                                以下为竞价结果截图：</div>
                                            <span slot="description">
                                                <img src="../../img/help/t12.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="7" tab="成交通知书">
                                    <h1>成交通知书</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">贵供应商单位在以下包组中成交，请在竞价结果公告发布后的<span class="color-red">三个工作日内</span>缴纳成交服务费<br/>代理机构确认成交服务费全部到账后才能开放下载。</div>
                                            <span slot="description">
                                                <img src="../../img/help/t13.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="8" tab="合同备案">
                                    <h1>合同备案</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">供应商将与采购人签订的合同上传至此处</div>
                                            <span slot="description">
                                                <img src="../../img/help/t14.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                            </a-tabs>
<!--                            <div style="margin-left: 170px">-->
<!--                                <h2 class="mt-5">仍需要其他帮助？</h2>-->
<!--                                <div class="division"></div>-->
<!--                                <ul class="t2">-->
<!--                                    <li>电话：020-58797485</li>-->
<!--                                </ul>-->
<!--                            </div>-->

                        </a-card>
                    </a-col>
                </a-row>
            </div>

        </div>

        <CommonFooter/>
    </div>
</template>

<script>
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from '../common/CommonFooter'

    export default {
        components: {
            CommonHeader,
            CommonFooter
        },
        data () {
            return {
                qqq: this.$route.query.id
            }
        },
        methods: {
          findPass() {
            this.$router.push({path:'/message/SysHelp'})
          }
        }
    }
</script>

<style scoped>
    .t1{
        list-style: none;
        font-size: 0;
        padding: 15px 0;
    }
    .t1 li{
        width: 25%;
        display: inline-block;
        margin: 15px 0;
    }
    .t1 li a{
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #262626;
    }
    .t1 li a:hover{
        color: #2f7fe3;
    }
    .t1 li a img{
        margin-right: 8px;
    }

    .t2{
        list-style: none;
        font-size: 0;
        padding: 15px 0;
    }
    .t2 li{
        width: 23%;
        display: inline-block;
        background: #f7f7f7;
        font-size: 16px;
        padding: 12px;
        color: #000;
        margin-left: 2.66666666%;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .t2 li:nth-child(4n-3){
        margin-left: 0;
    }
    .ant-card-bordered{
        border: none;
    }
    /deep/ .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title{
        color: #000;
    }
    /deep/ .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description{
        color: rgba(0, 0, 0, 0.65);
    }
    /deep/ .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon{
        color: #fff;
    }
    /deep/ .ant-steps-item-wait .ant-steps-item-icon {
        background-color: rgb(24, 144, 255);
        border-color: rgb(24, 144, 255);
    }
    .ant-steps-item-description img{
        box-shadow: rgba(0, 0, 0, 0.2) 0 3px 9px;
        width: 830px;
        margin: 30px auto
    }
</style>
